import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import * as styles from './NewClient.scss';
var NewClientSummary = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClientSummary, _Component);

  var _super = _createSuper(NewClientSummary);

  function NewClientSummary() {
    var _this;

    _classCallCheck(this, NewClientSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (title, amount) {
      var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var subtext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.summaryItemTitle
      }, title), /*#__PURE__*/React.createElement("span", {
        className: styles.summaryItemAmount
      }, subtract && /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: 4
        }
      }, "-"), amount)), subtext && /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemSecondary
      }, subtext));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFinePrintItem", function (text) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItemWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.finePrintText
      }, text)));
    });

    _defineProperty(_assertThisInitialized(_this), "getAdsCommissionPercent", function () {
      var val = "".concat(_this.props.orgConfig.adsCommissionPercent);

      if (parseFloat(val) < 0 || parseFloat(val) > 25 || isNaN(parseFloat(val)) || !"".concat(val).match(/^[-+]?[0-9]*\.?[0-9]+$/)) {
        return '-';
      }

      return val;
    });

    return _this;
  }

  _createClass(NewClientSummary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          orgConfig = _this$props.orgConfig,
          totals = _this$props.totals;
      var _wrapStyle = {};
      var wrapStyle = Object.assign({}, _wrapStyle, this.props.wrapStyle); // contract derived values

      var partnerName = contractInfo.contract.businessName;
      var adsCommissionAmount = this.getAdsCommissionPercent();
      return /*#__PURE__*/React.createElement("div", {
        className: styles.summaryWrap,
        style: wrapStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.summaryTopWrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, "Billing Summary"), totals.totalBilledToClient > 0 && this.renderItem('Total Billed To Client', this.formatCurrency(totals.totalBilledToClient)), totals.totalBilledToPartner > 0 && orgConfig.billingMethod === 'ads_only' && totals.totalBilledToPartner > 0 && this.renderItem('Total Billed To Partner', this.formatCurrency(totals.totalBilledToPartner))), orgConfig.billingMethod === 'end_to_end' && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, "Management Summary"), this.renderItem('Management Fee', this.formatCurrency(totals.managementFee)), totals.managementFee > totals.licenseFee && this.renderItem('Likeable Local License Fee', this.formatCurrency(totals.licenseFee), true), totals.managementFee > totals.licenseFee && this.renderItem('Transaction Fee', this.formatCurrency(totals.transactionFee), true), totals.partnerPaymentSubtotal > 0 && this.renderItem("".concat(partnerName, " Payment Subtotal"), this.formatCurrency(totals.partnerPaymentSubtotal))), parseFloat(orgConfig.adsBudget) > 0 && /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.summaryTitle
      }, this.props.partnerSubtype === 'affiliate' ? 'Ads Budget' : 'Ads Commission Summary'), this.renderItem(this.props.partnerSubtype === 'affiliate' ? 'Total Billed To Client' : "Ads Commission (".concat(adsCommissionAmount, "% of $").concat(orgConfig.adsBudget, ")"), this.props.partnerSubtype === 'affiliate' ? this.formatCurrency(totals.adsBudget) : this.formatCurrency(totals.adsCommission))), totals.monthlyNet > 0 && this.props.partnerSubtype !== 'affiliate' && /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.totalSection)
      }, this.renderItem("Total ACH Payment To ".concat(partnerName), this.formatCurrency(totals.monthlyNet)))), !this.props.edit && !this.props.isClientDetail && /*#__PURE__*/React.createElement("section", {
        className: "".concat(styles.summarySection, " ").concat(styles.finePrintSection)
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 16
        }
      }, this.renderFinePrintItem("Credit cards will be charged on the ".concat(moment().format('Do'), " of each month.")))));
    }
  }]);

  return NewClientSummary;
}(Component)) || _class);
export { NewClientSummary as default };